import React from 'react';

import ArtifactHealthItem from './ArtifactHealthItem';
import { artifactHealth } from './../helpers';

const ArtifactHealthLegend = () => (
  <div>
    <fieldset>
      <legend>Legend:</legend>
    </fieldset>
    {
      artifactHealth.ARTIFACT_HEALTH_STATUSES.map((status, i) => (
        <div key={i} style={{ paddingBottom: '5px' }}>
          <ArtifactHealthItem symbol={status.symbol} color={status.color}>
            {status.name}
          </ArtifactHealthItem>
        </div>
      ))
    }
  </div>
);

export default ArtifactHealthLegend;


// WEBPACK FOOTER //
// src/Components/ArtifactHealthLegend.jsx